<div id="dropin-container" [class.display-none]="loading" [class.readonly]="!editing"></div>
